import { Component, OnInit } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';

import { TopicListResponse } from 'src/app/modal/topic/topicListResponse';
import { TopicService } from 'src/app/service/topic/topic.service';
import { DmlTopicComponent } from 'src/app/pagina-admin/dashboard/gestionProductos/mant-topic/dml-topic/dml-topic.component';

@Component({
  selector: 'app-mant-topic',
  templateUrl: './mant-topic.component.html',
  styleUrls: ['./mant-topic.component.scss']
})
export class MantTopicComponent implements OnInit {

  constructor(private topicService:TopicService,
    private utilitarioService: UtilitarioService,
    private maestrasService: MaestrasService,
    private modalService: MDBModalService,
    ) { }

  txtdescripcion:String = "";
  cboEstado:String = "";
  modalRefAnioDml: MDBModalRef;
  listEstado:RespuestaComun = new RespuestaComun();
  headElements = ['Tema','Orden', 'Estado']; //quitado 'Editar'
  listSubmenu:TopicListResponse = new TopicListResponse();
  
  page = 1;
  pageSize = 9;

  ngOnInit(): void {
    this.cargarDatoInicial();
    this.onBuscar();
  }

  onBuscar(){
    this.utilitarioService.loading = true;
    this.topicService.obtenerAdminList(this.txtdescripcion.toString(), this.cboEstado.toString()).subscribe(data=>{
      this.listSubmenu = data;
      // console.log(data);
      this.utilitarioService.loading = false;
    })
  }

  onNuevo(id:String){
    this.modalRefAnioDml = this.modalService.show(DmlTopicComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Nuevo Topico',
          x_proceso:'I',
        }
      }
    );
  }

  onEditar(id:String){
    this.modalRefAnioDml = this.modalService.show(DmlTopicComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Editar Topico',
          x_proceso:'U',
        }
      }
    );
  }

  cargarDatoInicial(){

    this.utilitarioService.loading = true;
    this.listEstado = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_STATUS_TABLA").subscribe(data=>{
      this.listEstado = data;      
      this.utilitarioService.loading = false;
    });

  }

}
